import React, { useEffect, useRef, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { HeartHandshake, CheckCircle2, XCircle } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const { refreshMe } = useAuth();
  const [state, setState] = useState("loading");
  const [msg, setMsg] = useState("");
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    if (!token) { setState("error"); setMsg("This verification link is invalid."); return; }
    (async () => {
      try {
        await api.post("/auth/verify-email", { token });
        await refreshMe();
        setState("ok");
      } catch (e) {
        setState("error");
        setMsg(apiError(e));
      }
    })();
  }, [token, refreshMe]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-cream px-4">
      <div className="bg-white rounded-2xl border-2 border-border shadow-sm p-10 max-w-md w-full text-center">
        {state === "loading" && (
          <>
            <div className="w-16 h-16 rounded-full bg-terracotta flex items-center justify-center mx-auto mb-5 animate-pulse">
              <HeartHandshake className="text-white" size={32} strokeWidth={2.5} />
            </div>
            <p className="text-forest-700 text-lg">Verifying your email…</p>
          </>
        )}
        {state === "ok" && (
          <>
            <CheckCircle2 size={56} className="mx-auto text-forest-700 mb-4" strokeWidth={2} />
            <h1 className="font-head text-2xl font-bold text-forest-900 mb-2">Email verified!</h1>
            <p className="text-forest-700 text-lg mb-6">Thank you — your account is now verified.</p>
            <button onClick={() => navigate("/app")} data-testid="verify-continue"
              className="min-h-[56px] px-8 rounded-full bg-terracotta text-white font-bold text-lg hover:bg-terracotta-dark transition-colors">Continue to Connect</button>
          </>
        )}
        {state === "error" && (
          <>
            <XCircle size={56} className="mx-auto text-destructive mb-4" strokeWidth={2} />
            <h1 className="font-head text-2xl font-bold text-forest-900 mb-2">Couldn't verify</h1>
            <p className="text-forest-700 text-lg mb-6">{msg}</p>
            <button onClick={() => navigate("/app")} data-testid="verify-continue"
              className="min-h-[56px] px-8 rounded-full bg-white border-2 border-forest-900 text-forest-900 font-bold text-lg hover:bg-forest-900 hover:text-white transition-colors">Go to Connect</button>
          </>
        )}
      </div>
    </div>
  );
}
